<template>
  <div class="q-pa-md">
    <q-card class="my-card" flat bordered>
      <q-item>
        <q-item-section avatar>
          <q-icon name="people" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Randevular</q-item-label>
        </q-item-section>
      </q-item>
      <q-separator />
      <q-card-section horizontal>
        <q-card-section>
          <div class="col-2 q-pa-md">
            <CreateAppointment />
          </div>
          <div class="col-2 q-pa-md">
            <CreateMeeting />
          </div>
        </q-card-section>
        <q-separator vertical />
        <q-card-section class="col-4">
          Bu sayfadan sistemde tanimli randevulari yonetebilirsiniz.
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>
  <div class="q-pa-md">
    <div class="subcontent">
      <div class="row justify-center q-pa-md">
        <q-btn
          flat
          dense
          no-caps
          label="Onceki Ay"
          icon="arrow_back_ios"
          @click="onPrev"
        />
        <q-separator vertical />
        <span class="text-subtitle q-pa-md">{{ currentMonth }}</span>
        <q-separator vertical />
        <q-btn
          flat
          dense
          no-caps
          label="Sonraki Ay"
          icon-right="arrow_forward_ios"
          @click="onNext"
        />
      </div>
      <div class="row justify-center">
        <div style="display: flex; width: 100%">
          <q-calendar-month
            ref="calendar"
            v-model="selectedDate"
            animated
            bordered
            focusable
            hoverable
            no-active-date
            :day-min-height="60"
            :day-height="0"
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            locale="tr"
            @change="onChange"
          >
            <template #day="{ scope: { timestamp } }">
              <template
                v-for="event in appointments.get(timestamp.date)"
                :key="event.id"
              >
                <div :class="badgeClasses(event)" @click="event.dialog = true">
                  <div class="title q-calendar__ellipsis">
                    {{ event.title }}
                    <q-tooltip
                      anchor="top middle"
                      self="bottom middle"
                      :offset="[10, 10]"
                    >
                      {{ event.title }}
                    </q-tooltip>
                  </div>
                </div>
                <q-dialog v-model="event.dialog"
                  ><ViewAppointment :appointment="event" />
                </q-dialog>
              </template>
            </template>
          </q-calendar-month>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QCalendarMonth, today } from '@quasar/quasar-ui-qcalendar/src/index.js'
import '@quasar/quasar-ui-qcalendar/src/QCalendarVariables.sass'
import '@quasar/quasar-ui-qcalendar/src/QCalendarTransitions.sass'
import '@quasar/quasar-ui-qcalendar/src/QCalendarMonth.sass'
import { ref, defineComponent, inject } from 'vue'
import axios from 'axios'
import moment from 'moment'
import CreateAppointment from '../components/appointment/Create.vue'
import CreateMeeting from '../components/appointment/CreateMeeting.vue'
import ViewAppointment from '../components/appointment/View.vue'
import * as eventNames from '../utils/events'
import * as timestuff from '../utils/timetravel'
export default defineComponent({
  name: 'Calendar',
  components: {
    QCalendarMonth,
    CreateAppointment,
    CreateMeeting,
    ViewAppointment,
  },
  setup() {
    /*
      Appointments Map <Day, Appointments>
    */
    const appointments = ref(new Map())
    const currentMonth = ref('')

    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_APPOINTMENTS, () => {
      // Start and End of the current month to query appointments
      const start = moment().startOf('month').toISOString()
      const end = moment().endOf('month').toISOString()
      getAppointments(start, end)
    })

    function badgeClasses(event) {
      switch (event.status) {
        case 'PLANNED':
          return {
            [`text-black bg-amber q-pa-xs`]: true,
            'rounded-border': true,
          }
        case 'CANCELLED':
          return {
            [`text-white bg-red q-pa-xs`]: true,
            'rounded-border': true,
          }
        case 'COMPLETED':
          return {
            [`text-white bg-secondary q-pa-xs`]: true,
            'rounded-border': true,
          }
      }
    }

    function appointmentTypeSlug(type) {
      switch (type) {
        case 'INTRODUCTION':
          return 'T'
        case 'REGIONAL_LOSS':
          return 'BZ'
        case 'REGIME_SESSION':
          return 'DS'
      }
    }

    function eventName(appointment) {
      // [Type : CustomerName (start-end time)]
      return (
        appointmentTypeSlug(appointment.appointmentType) +
        ': ' +
        appointment.customerName +
        ' (' +
        timestuff.humanReadableAppointmentTime(
          appointment.appointmentStart,
          appointment.appointmentEnd
        ) +
        ')'
      )
    }

    function getAppointments(start, end) {
      // Clear the map before getting appointments
      appointments.value.clear()

      axios.get(`/appointments?start=${start}&end=${end}`).then((response) => {
        response.data.forEach((appointment) => {
          const startDate = moment(appointment.appointmentStart)

          // Event Date
          const date = moment(appointment.appointmentStart)
            .utc()
            .format('YYYY-MM-DD')

          // Initialize event array for the date
          if (!appointments.value.get(date)) {
            appointments.value.set(date, [])
          }

          // Add event to the event map
          appointments.value.get(date).push({
            id: appointment.id,
            customerName: appointment.customerName,
            title: eventName(appointment),
            type: appointment.appointmentType,
            status: appointment.appointmentStatus,
            date: startDate,
            start: appointment.appointmentStart,
            end: appointment.appointmentEnd,
            dialog: false,
          })
        })
      })
    }

    return {
      appointments,
      currentMonth,
      appointmentTypeSlug,
      eventName,
      badgeClasses,
      getAppointments,
    }
  },
  data() {
    return {
      selectedDate: today(),
    }
  },
  methods: {
    onPrev() {
      // Move calendar to previous month
      this.$refs.calendar.prev()
    },
    onNext() {
      // Move calendar to next month
      this.$refs.calendar.next()
    },
    onChange(data) {
      /**
       * Get appointments between data.start and data.end.
       * The format of the dates are 2022-01-03
       */
      let start = moment(data.start, 'YYYY-MM-DD').toISOString()
      let end = moment(data.end, 'YYYY-MM-DD').toISOString()
      this.getAppointments(start, end)
      console.log(data)
      /**
       * data.days has all the days within the view. It can start with the
       * last day of prevoius month, and can end with the next month's first days.
       * ex: When selected month is February, but days can start with January's 30th
       * can end with March 1st. To update the selected month easily, use the mid item
       * in the data.days array.
       */
      let midDate = data.days[Math.round(data.days.length / 2)].date
      this.currentMonth = moment(midDate, 'YYYY-MM-DD').format('MMMM YYYY')
    },
  },
})
</script>
